import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { API_URL } from "../../utils/Url";
import axios from "axios";
import { toast } from "react-toastify";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Email & password are required");
      return;
    }

    try {
      setLoading(true);
      // toast.loading("Logging in...", { id: "login" });

      const { data } = await axios.post(`${API_URL}/api/admin/login/admin`, {
        email,
        password,
      });

      // ✅ SUCCESS
      if (data?.token) {
        sessionStorage.setItem("matrimonyAdmin", JSON.stringify(data));
        sessionStorage.setItem("token", data.token);
        toast.success("Login successful ✅", { id: "login" });

        navigate("/dashboard", { replace: true });
      } else {
        toast.error(data?.message || "Invalid credentials", {
          id: "login",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Login failed. Please try again",
        { id: "login" },
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" style={{ backgroundColor: "#9ff0c3ff" }}>
      <div className="login-card">
        <div className="login-brand">
          <div className="logo-circle">⚖️</div>
          <div>
            <h1>Advocate Matrimony</h1>
            <p>Admin Panel Login</p>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Admin Email</label>
            <input
              type="email"
              placeholder="Enter admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "🔐 Login"}
          </button>

          <p className="login-hint">
            Demo: admin@advocatematrimony.com / admin123
          </p>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
